import Immutable from "immutable";
import React from "react";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import { SearchCriterion } from "../common/SearchCriterion";
import { UtilisationSearchRangeComponent, UtilisationSearchRangeProps } from "./UtilisationSearchRangeComponent";
import { requiredRolesType } from "../../../../common/types/search/search";

interface UtilisationSearchRangeCriterionProps extends UtilisationSearchRangeProps {
	criterionKey: string;
	label: string;
	quickSearch?: boolean;
	prefix?: string;
	requiredRoles?: requiredRolesType;
}

export const UTILISATION_SEARCH_RANGE_CRITERION_INITIAL_STATE = Immutable.Map();

export const UtilisationSearchRangeCriterion = ({
	criterionKey,
	label,
	prefix,
	quickSearch = false,
	requiredRoles,
	...props
}: UtilisationSearchRangeCriterionProps) => {
	const { currentInput, onInputChange, onClearInput } = useFormComponentState(
		criterionKey,
		UTILISATION_SEARCH_RANGE_CRITERION_INITIAL_STATE,
	);

	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
		>
			<UtilisationSearchRangeComponent
				criterionKey={criterionKey}
				currentInput={currentInput}
				label={label}
				onClearInput={onClearInput}
				onInputChange={onInputChange}
				prefix={prefix}
				quickSearch={quickSearch}
				{...props}
			/>
		</SearchCriterion>
	);
};
